import EventDispatcher from '@/webgl/utils/EventDispatcher';

class Events extends EventDispatcher {
}

export default new Events();